export const appName = 'buildings';

export const MASS_EDITOR_ENTITY_STATE = 'state';
export const MASS_EDITOR_ENTITY_TAGS = 'tags';
export const MASS_EDITOR_ENTITY_PRODUCT_STATES = 'productStates';
